const blocks = {
  QuickNavigation: 'QuickNavigationBlock',
  Facility: 'FacilityBlock',
  PopularActivity: 'PopularActivityBlock',
  LatestNews: 'LatestNewsBlock',
  Contact: 'ContactBlock',
};
export default blocks;
